module.exports = __webpack_public_path__ + "static/media/home.76dc2d62.svg";